import React from "react";
import DataGridPersonnel from "./datagrid/DataGridPersonnel";

const Personnel = () => {
  return (
    <div>
      <div>
        {" "}
        <p className=" text-success h5 ">Personnels assurances </p>
      </div>
      <DataGridPersonnel />
    </div>
  );
};

export default Personnel;
